import { toolLocales } from "@modules/investor-relations/utils";
import { Outlet, useParams } from "@remix-run/react";
import { useEffect } from "react";

let eurolandGlobalInitialized = false;

const EUROLAND_AUTO_HEIGHT_SCRIPT_ID = "euroland-autoheight-script";
const EUROLAND_AUTO_HEIGHT_SCRIPT_URL =
  "//tools.euroland.com/tools/common/eurolandiframeautoheight/eurolandtoolsintegrationobject.js";

function EurolandGlobalIntegrationScript() {
  useEffect(() => {
    if (eurolandGlobalInitialized || typeof document === "undefined") {
      return;
    }
    eurolandGlobalInitialized = true;

    const w = window as Window & { eurolandClientCfg?: object[] };
    const d = document;
    const key = "eurolandClientCfg";
    const company = "SA-2240";
    const regKey = null;
    const svcUrl = "https://tools.eurolandir.com/tools/";

    w[key] = w[key] || [];
    w[key]!.push({ company });
    w[key]!.push({ reg_key: regKey });
    w[key]!.push({ svc_url: svcUrl });

    const firstScript = d.getElementsByTagName("script")[0];
    const script = d.createElement("script");
    script.async = true;
    script.src = `${svcUrl}/integration/embed.js`;
    script.id = "euroland-integration";

    if (!d.getElementById(script.id) && firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  }, []);

  return null;
}

function EurolandAutoHeightScript() {
  useEffect(() => {
    const w = window as any;

    const initIframe = (iframe: Element) => {
      if (w.EurolandToolIntegrationObject) {
        w.EurolandToolIntegrationObject.set(iframe);
      }
    };

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
          if (
            node instanceof HTMLIFrameElement &&
            node.classList.contains("euroland-iframe")
          ) {
            initIframe(node);
          } else if (node instanceof Element) {
            node
              .querySelectorAll("iframe.euroland-iframe")
              .forEach(initIframe);
          }
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    if (!document.getElementById(EUROLAND_AUTO_HEIGHT_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = EUROLAND_AUTO_HEIGHT_SCRIPT_ID;
      script.src = EUROLAND_AUTO_HEIGHT_SCRIPT_URL;
      script.type = "text/javascript";
      script.onload = () => {
        document.querySelectorAll("iframe.euroland-iframe").forEach(initIframe);
      };
      document.body.appendChild(script);
    } else {
      document.querySelectorAll("iframe.euroland-iframe").forEach(initIframe);
    }

    return () => observer.disconnect();
  }, []);

  return null;
}

function EurolandAISearch() {
  const { lang = "en" } = useParams();
  const { standard } = toolLocales(lang);

  return (
    <euroland-tool data-tool-name="aisearch" data-tool-language={standard} />
  );
}

export default function InvestorRelationsLayout() {
  return (
    <>
      <EurolandGlobalIntegrationScript />
      <EurolandAutoHeightScript />
      <EurolandAISearch />
      <Outlet />
    </>
  );
}
